import { render } from "./huokeArticles.vue?vue&type=template&id=d6c1618c"
import script from "./huokeArticles.vue?vue&type=script&lang=js"
export * from "./huokeArticles.vue?vue&type=script&lang=js"

import "./huokeArticles.vue?vue&type=style&index=0&id=d6c1618c&lang=scss"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__